/**
 * Adds zero padding to the day and the month of a date string like "YYYY.M.D".
 *
 * @param dateStr - An string containing a date like "YYYY.MM?.DD?"
 * @return An string contining a date like "YYYY/MM/DD"
 */
function padDateString(dateStr) {
    return dateStr.replace(/(\d+)\D+(\d+)\D+(\d+)/, (_, year, month, day) => `${year}/${month.padStart(2, '0')}/${day.padStart(2, '0')}`);
}

export { padDateString as p };
